
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { SalaryVerificationSettings } from '@/components/admin/salary/SalaryVerificationSettings';
import { useSalaryVerification } from '@/hooks/useSalaryVerification';

const AdminSalaryVerificationPage = () => {
  const { settings, updateSettings } = useSalaryVerification(0, 0); // Month/year not needed for settings

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full">
        <AdminSidebar />
        <SidebarInset>
          <div className="container mx-auto px-4 py-8">
            <div className="mb-6">
              <h1 className="text-2xl font-bold">การตั้งค่าระบบยืนยันเงินเดือนครู</h1>
              <p className="text-muted-foreground">
                จัดการระบบยืนยันข้อมูลก่อนเข้าดูเงินเดือน
              </p>
            </div>

            <SalaryVerificationSettings
              settings={settings}
              onUpdateSettings={updateSettings}
            />
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default AdminSalaryVerificationPage;
